import { useQuery } from '@tanstack/react-query';
import { USE_MOCK, analyticsApi, ApiError } from '@/api/client';
import type { PersonalGrowthResponse } from '@/api/types';

// Mock growth data — monthly trend for the demo user
const MOCK_GROWTH: PersonalGrowthResponse = {
  evaluatedId: 'demo-user',
  history: [
    { month: '2025-07', overallAverage: 2.1, fundamentals: [{ fundamentalId: 'learner', average: 2.0 }, { fundamentalId: 'player-owner', average: 2.3 }, { fundamentalId: 'communicator', average: 2.1 }, { fundamentalId: 'team-builder', average: 2.0 }] },
    { month: '2025-08', overallAverage: 2.4, fundamentals: [{ fundamentalId: 'learner', average: 2.5 }, { fundamentalId: 'player-owner', average: 2.4 }, { fundamentalId: 'communicator', average: 2.3 }, { fundamentalId: 'team-builder', average: 2.4 }] },
    { month: '2025-09', overallAverage: 2.7, fundamentals: [{ fundamentalId: 'learner', average: 2.8 }, { fundamentalId: 'player-owner', average: 2.6 }, { fundamentalId: 'communicator', average: 2.7 }, { fundamentalId: 'team-builder', average: 2.7 }] },
    { month: '2025-10', overallAverage: 2.9, fundamentals: [{ fundamentalId: 'learner', average: 3.0 }, { fundamentalId: 'player-owner', average: 2.8 }, { fundamentalId: 'communicator', average: 2.9 }, { fundamentalId: 'team-builder', average: 2.9 }] },
    { month: '2025-11', overallAverage: 3.1, fundamentals: [{ fundamentalId: 'learner', average: 3.2 }, { fundamentalId: 'player-owner', average: 3.0 }, { fundamentalId: 'communicator', average: 3.1 }, { fundamentalId: 'team-builder', average: 3.1 }] },
    { month: '2025-12', overallAverage: 3.3, fundamentals: [{ fundamentalId: 'learner', average: 3.4 }, { fundamentalId: 'player-owner', average: 3.2 }, { fundamentalId: 'communicator', average: 3.3 }, { fundamentalId: 'team-builder', average: 3.3 }] },
    { month: '2026-01', overallAverage: 3.4, fundamentals: [{ fundamentalId: 'learner', average: 3.5 }, { fundamentalId: 'player-owner', average: 3.3 }, { fundamentalId: 'communicator', average: 3.4 }, { fundamentalId: 'team-builder', average: 3.4 }] },
  ],
};

export function usePersonalGrowth(userId?: string) {
  return useQuery<PersonalGrowthResponse>({
    queryKey: ['personalGrowth', userId],
    retry: false,
    queryFn: async () => {
      if (USE_MOCK) return MOCK_GROWTH;
      try {
        return await analyticsApi.getPersonalGrowth(userId);
      } catch (err: unknown) {
        if (err instanceof ApiError && err.status === 404) return { evaluatedId: '', history: [] };
        if (err instanceof TypeError) return { evaluatedId: '', history: [] };
        throw err;
      }
    },
  });
}
